import requestProvider from "./axiosHandler";

const getAllTax = () => {
    return requestProvider
        .get('/tax/get-all')
};

const createTax = (list) => {

    return requestProvider
        .post('/tax', {
            name: list.name,
            code: list.code,
            description: list.description,
            ratio: list.ratio
        })
};

const updateTax = (list) => {

    return requestProvider
        .put('/tax', {
            name: list.name,
            code: list.code,
            description: list.description,
            ratio: list.ratio,
            id: list.id
        })
};

const deleteTax = (id) => {

    return requestProvider
        .delete(`/tax/${id}`)
};

const getTaxById = (id) => {

    return requestProvider
        .get(`/tax/${id}`)
};

const getTaxesWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/tax?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 

export {getAllTax, createTax, updateTax, deleteTax, getTaxById, getTaxesWithPage}